import React from 'react';
import PropTypes from 'prop-types';
import './Result.scss';
import Wrapper from 'components/Wrapper';
import Parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { ROUTES } from 'config/constants';
import { imageFit } from 'utils/cloudinaryHelper';

function Result({ item, type, data, history }) {
    function checkValue(name, value) {
        return value.map((param, i) => {
            const checkPrameter = item.selectedAttribute.find(e => e.name === name && e.value.find(e => e === param));

            if (checkPrameter) {
                return <div className='resultItemItems aciveResultItem' key={i}>
                    {param}
                </div>;
            } else {
                return <div className='resultItemItems' key={i}>
                    {param}
                </div>;
            }
        }

        );
    }

    function calParams(params) {
        const length = params.length;

        return params.map((config, i) =>
            <div className='resultItem--content--params--flex' key={i}>
                <div className='resultItemTitle' >
                    {config.name}
                </div>
                {checkValue(config.name, config.value)}
            </div>
        );
        
        // This is for condition if user wants items sliced by four column
        // if (length > 4 && length < 11) {
        //     // length between 4 and 10

        //     const firstHalf = params.slice(0, 4);
        //     const secondHalf = params.slice(4, params.length);

        //     return <div className='resultItem--content--items' >
        //         <div className='resultItem--content--items--item'>
        //             {firstHalf.map((config, i) =>
        //                 <div className='resultItem--content--items--item--content' key={i}>
        //                     <div className='resultItemTitle' >
        //                         {config.name}
        //                     </div>
        //                     {checkValue(config.name, config.value)}
        //                 </div>
        //             )}
        //         </div>
        //         <div className='resultItem--content--items--item'>
        //             {secondHalf.map((config, i) =>
        //                 <div className='resultItem--content--items--item--content' key={i}>
        //                     <div className='resultItemTitle' >
        //                         {config.name}
        //                     </div>
        //                     {checkValue(config.name, config.value)}
        //                 </div>
        //             )}
        //         </div>
        //     </div>;
        // }

        // if (length > 10) {
        //     const half = Math.ceil(params.length / 2);

        //     const firstHalf = params.splice(0, half);
        //     const secondHalf = params.splice(-half);

        //     return <div className='resultItem--content--items' >
        //         <div className='resultItem--content--items--item'>
        //             {firstHalf.map((config, i) =>
        //                 <div className='resultItem--content--items--item--content' key={i}>
        //                     <div className='resultItemTitle' >
        //                         {config.name}
        //                     </div>
        //                     {checkValue(config.name, config.value)}
        //                 </div>
        //             )}
        //         </div>
        //         <div className='resultItem--content--items--item'>
        //             {secondHalf.map((config, i) =>
        //                 <div className='resultItem--content--items--item--content' key={i}>
        //                     <div className='resultItemTitle' >
        //                         {config.name}
        //                     </div>
        //                     {checkValue(config.name, config.value)}
        //                 </div>
        //             )}
        //         </div>
        //     </div>;
        // }
    }

    function goToVariant() {
        history.push(ROUTES.VARIATION(item.id, (!item.name_inherited ? item.name : data.name).toLowerCase().replace(/ /g, '_')));
    }

    return (<div className={type === 'odd' ? 'odd-item resultItem' : 'resultItem'}>
        <Wrapper>
            <h2 className='resultItem--title' onClick={goToVariant}>{!item.name_inherited ? item.name : data.name}</h2>
            <div className='resultItem--content'>
                <div className='resultItem--content--img' onClick={goToVariant}>
                    <img src={!item.images_inherited ? imageFit(item.medias.image[0].url, 260) : imageFit(data.medias.image[0].url, 260)} alt={!item.name_inherited ? item.name : data.name}/>
                </div>

                <div className='resultItem--content--params--details'>
                    <div className='resultItem--content--params--items'>
                        {item.attributes && calParams(item.attributes)}
                    </div>
                    {!item.long_description_inherited && item.long_description &&
                        <div className='resultItem--content--params--moreDetailsdecs'>
                            <div className='resultItem--content--params--moreDetailsdecs--title'>
                                <span className='resultItem--content--params--moreDetailsdecs--title--span'>
                                    Product Description
                                </span>
                            </div>
                            <div className='resultItem--content--params--moreDetailsdecs--content'>
                                {Parse(item.long_description)}
                            </div>
                        </div>
                    }
                    <div className='resultItem--content--params--moreDetails tags-details'>
                        <div className='resultItem--content--params--moreDetails--title'>
                            <span className='resultItem--content--params--moreDetails--title--span'>
                                Tags
                            </span>
                        </div>
                        <div className='resultItem--content--params--moreDetails--content'>
                            {item.tags_inherited
                                ? data.tags.map((add, i) => {
                                    if (add.visible) {
                                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        return <Link className='resultItem--content--params--moreDetails--content--tags' key={i} to={ROUTES.TAG(add.slug)}>
                                            {add.name}
                                        </Link>;
                                    } else {
                                        return true;
                                    }
                                })
                                : item.tags && item.tags.map((add, i) => {
                                    if (add.visible) {
                                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        return <Link className='resultItem--content--params--moreDetails--content--tags' key={i} to={ROUTES.TAG(add.slug)}>
                                            {add.name}
                                        </Link>;
                                    } else {
                                        return true;
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className='resultItem--content--params--moreDetails'>
                        <div className='resultItem--content--params--moreDetails--title'>
                            <span className='resultItem--content--params--moreDetails--title--span'>
                                SKU :
                            </span>
                        </div>
                        <div className='resultItem--content--params--moreDetails--content'>
                            <span className='resultItem--content--params--moreDetails--content--value'>
                                {item.sku}
                            </span>
                        </div>
                    </div>

                    {item.part_no &&
                        <div className='resultItem--content--params--moreDetails'>
                            <div className='resultItem--content--params--moreDetails--title'>
                                <span className='resultItem--content--params--moreDetails--title--span'>
                                    Part Number:
                                </span>
                            </div>
                            <div className='resultItem--content--params--moreDetails--content'>
                                <span className='resultItem--content--params--moreDetails--content--value'>
                                    {item.part_no}
                                </span>
                            </div>
                        </div>
                    }
                </div>

            </div>
        </Wrapper>
    </div>);
}

export default Result;

Result.propTypes = {
    item: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.object,
    history: PropTypes.object
};
